import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk'
import { environment, featureFlagClientId, featureFlagPerBrowserKey } from 'Config'

const ANONYMOUS_KEY = 'zenqms-anonymous-user'

// The login page is pre-authentication, so there is never a member to target on: every
// evaluation uses an anonymous multi-context.
// - Shared key (default): every visitor is the same context, the one the UI app boots with. One
//   context in LD usage, and a percentage rollout serves everyone the same variation.
// - Per-browser key (`featureFlagPerBrowserKey`, production and sandbox only): with no key, the SDK
//   generates a UUID and keeps it in localStorage, so percentage rollouts bucket each browser
//   individually. Every browser counts as a context in LD usage, hence opt-in.
export const buildAnonymousContext = perBrowserKey => {
  const key = perBrowserKey ? {} : { key: ANONYMOUS_KEY }
  return {
    kind: 'multi',
    user: { kind: 'user', anonymous: true, ...key },
    member: { kind: 'member', anonymous: true, ...key },
  }
}

const anonymousContext = buildAnonymousContext(Boolean(featureFlagPerBrowserKey))

// Deliberately no `bootstrap: 'localStorage'` - a stale cached `true` is indistinguishable
// from a fresh one. Flags read before the SDK is ready are `undefined`, which every consumer
// must treat as "off" (see LoginLogo).
export const withFeatureFlags = featureFlagClientId
  ? withLDProvider({
    clientSideID: featureFlagClientId,
    context: anonymousContext,
    options: {
      streaming: true,
      application: {
        id: 'login',
        name: 'Login',
        version: environment,
      },
    },
  })
  // No client id configured (unknown/local-only env): render without LD, all flags off.
  : Component => Component

export const useFeatureFlags = () => useFlags()

export default {}
